import { AnyAction, createSlice } from "@reduxjs/toolkit";

type MessagesState = {
  pending: number;
  fulfilled: number;
  rejected: number;
};

const initialState: MessagesState = {
  pending: 0,
  fulfilled: 0,
  rejected: 0,
};

function isAsyncThunkAction(action: AnyAction): action is { type: string } {
  return (
    action.type.endsWith("pending") ||
    action.type.endsWith("fulfilled") ||
    action.type.endsWith("rejected")
  );
}

export const asyncCounterSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => isAsyncThunkAction(action),
      (state, action) => {
        if (action.type.endsWith("pending")) {
          state.pending++;
        }
        if (action.type.endsWith("fulfilled")) {
          state.fulfilled++;
        }
        if (action.type.endsWith("rejected")) {
          state.rejected++;
        }
      }
    );
  },
});

// export const { removeError } = loadingSlice.actions;
